import React, { useState } from 'react';
import ChatList from './chat/ChatList';
import ChatView from './chat/ChatView';

function AdminPanel({ userId, onBackClick }) {
  const [chatId, setChatId] = useState(null);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-900">
      {/* Left: Chat List */}
      <div className="w-full sm:w-96 border-r border-slate-700 overflow-y-auto bg-slate-900">
        <ChatList
          userId={userId}
          onSelect={setChatId}
          selectedChatId={chatId}
        />
      </div>

      {/* Right: Chat View */}
      <div className="hidden sm:flex flex-col flex-1 bg-slate-950">
        {chatId ? (
          <ChatView 
            chatId={chatId} 
            onBackClick={onBackClick} 
            userId={userId}
          />
        ) : (
          <div 
            className="flex-1 flex items-center justify-center text-slate-500 font-montserrat"
            style={{
              backgroundImage: 'url("https://storage.googleapis.com/fastmax-images/51046e67-3895-44b2-a2a6-bd1020f4b1f3-OIP.jpeg")',
              backgroundRepeat: 'repeat',
              backgroundColor: '#0b141a'
            }}
          >
            Selecciona un chat
          </div>
        )}
      </div>

      {/* Mobile: Show only active chat */}
      {chatId && (
        <div className="sm:hidden fixed inset-0 z-50 bg-slate-950">
          <ChatView 
            chatId={chatId} 
            onBackClick={() => setChatId(null)} 
            userId={userId}
          />
        </div>
      )}
    </div>
  );
}

export default AdminPanel;